import {getJournalSessionsCollectionPath, JournalSession, type JournalSessionDb} from '@cp/model';
import {collection, CollectionReference} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';

export function getJournalSessionCollection(uid: string): CollectionReference<JournalSession, JournalSessionDb> {
  return collection(firebaseFirestore, getJournalSessionsCollectionPath(uid)) as CollectionReference<
    JournalSession,
    JournalSessionDb
  >;
}
